import React, { useState, useEffect } from 'react';
import API from '../api';
import './AdvertisingCostsTable.css';

const AdvertisingCostsTable = ({ type = 'internal', title, description }) => {
  const [costs, setCosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0
  });
  const [totals, setTotals] = useState({
    service_spend: 0,
    loverlist_cost: 0,
    impressions: 0,
    clicks: 0
  });
  const loadCosts = async (page = 1) => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page,
        limit: pagination.limit
      });

      const endpoint = type === 'internal' ? '/advertising/internal-campaigns' : '/advertising/external-campaigns';
      const response = await API.get(`${endpoint}?${params}`);
      
      if (response.data.success) {
        setCosts(response.data.data.costs);
        setPagination(response.data.data.pagination);
        setTotals(response.data.data.totals);
      }
    } catch (error) {
      console.error('Errore nel caricamento costi:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCosts();
  }, []);

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
    loadCosts(newPage);
  };



  const formatCurrency = (amount) => {
    // Per importi molto piccoli, mostra 4 decimali
    if (amount < 0.01) {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      }).format(amount);
    }
    // Per importi normali, mostra 2 decimali
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('it-IT').format(num);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('it-IT');
  };

  const getServiceTypeLabel = () => {
    return type === 'internal' ? 'Campagne Loverlist' : 'Campagne Shopping Esterne';
  };

  return (
    <div className="advertising-costs-section">
      <div className="section-header">
        <h3>{title}</h3>
        <p className="section-description">{description}</p>
      </div>



      {/* Totali */}
      <div className="totals-section">
        <div className="total-card">
          <span className="total-label">Spesa Google Ads:</span>
          <span className="total-value">{formatCurrency(totals.service_spend)}</span>
        </div>
        <div className="total-card">
          <span className="total-label">Costo per te:</span>
          <span className="total-value">{formatCurrency(totals.loverlist_cost)}</span>
        </div>
        <div className="total-card">
          <span className="total-label">Impressions:</span>
          <span className="total-value">{formatNumber(totals.impressions)}</span>
        </div>
        <div className="total-card">
          <span className="total-label">Clicks:</span>
          <span className="total-value">{formatNumber(totals.clicks)}</span>
        </div>
      </div>

      {/* Tabella */}
      <div className="table-container">
        {loading ? (
          <div className="loading">Caricamento...</div>
        ) : costs.length === 0 ? (
          <div className="no-data">
            Nessun costo trovato per il periodo selezionato
          </div>
        ) : (
          <>
            <table className="advertising-costs-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Campagna</th>
                  <th>Spesa Google Ads</th>
                  <th>Costo per te</th>
                  <th>Impressions</th>
                  <th>Clicks</th>
                  {type === 'external' && <th>Account</th>}
                </tr>
              </thead>
              <tbody>
                {costs.map((cost) => (
                  <tr key={cost.id}>
                    <td>{formatDate(cost.cost_date)}</td>
                    <td>
                      <div className="campaign-info">
                        <span className="campaign-name">{cost.campaign_name || 'N/A'}</span>
                        <span className="campaign-id">{cost.campaign_id}</span>
                      </div>
                    </td>
                    <td className="amount">{formatCurrency(cost.service_spend_amount)}</td>
                    <td className="amount">{formatCurrency(cost.loverlist_cost_amount)}</td>
                    <td>{formatNumber(cost.impressions)}</td>
                    <td>{formatNumber(cost.clicks)}</td>
                    {type === 'external' && (
                      <td>{cost.merchant_account_id || 'N/A'}</td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Paginazione */}
            {pagination.totalPages > 1 && (
              <div className="pagination">
                <button
                  onClick={() => handlePageChange(pagination.page - 1)}
                  disabled={pagination.page === 1}
                  className="pagination-btn"
                >
                  Precedente
                </button>
                <span className="pagination-info">
                  Pagina {pagination.page} di {pagination.totalPages} 
                  ({pagination.total} record totali)
                </span>
                <button
                  onClick={() => handlePageChange(pagination.page + 1)}
                  disabled={pagination.page === pagination.totalPages}
                  className="pagination-btn"
                >
                  Successiva
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdvertisingCostsTable;
